










































































import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { EwellUser } from "@/model/ewellUser";
import UserMixin from "@/mixins/userMixin";

@Component({
  components: {
    AppAuthButton,
  },
})
export default class IbowAccountList extends Mixins(AxiosMixin, UserMixin) {
  /** ewellユーザー情報 */
  private ewellUsers: EwellUser[] = [];

  /** 絞込み用条件 */
  private filterObj = {
    name: "",
    keyword: "",
  };

  private headers = [
    {
      text: "復元",
      align: "center",
      sortable: false,
      value: "action_restore",
    },
    {
      text: "消去",
      align: "center",
      sortable: false,
      value: "action_delete",
    },
    {
      text: "iBowID",
      sorttable: true,
      value: "user_id",
    },
    {
      text: "氏名",
      sorttable: true,
      value: "name",
    },
    {
      text: "ふりがな",
      sorttable: true,
      value: "furigana",
    },
    {
      text: "メールアドレス",
      sorttable: false,
      value: "mail_address",
    },
    {
      text: "携帯電話番号",
      sorttable: false,
      value: "tel_no",
    },
    {
      text: "システムID",
      sorttable: false,
      value: "system_id",
    },
  ];

  /** eWeLLユーザー取得 */
  private fetchIbowAccounts() {
    this.postJsonCheck(
      window.base_url + "/api/ibowaccounts/deleted_list/get",
      {
        name: this.filterObj.name,
        keyword: this.filterObj.keyword,
      },
      (res) => {
        this.ewellUsers = res.data.ewell_users;
      }
    );
  }

  /** 復元ボタンクリック時 */
  private goRestore(id: number) {
    if (!confirm("アカウントを復元します\nよろしいですか？")) {
      return;
    }
    this.postJsonCheck(
      window.base_url + "/api/ibowaccount/restore",
      {
        id: id,
      },
      () => {
        this.fetchIbowAccounts();
      }
    );
  }

  /** 消去ボタンクリック時 */
  private goHardDelete(id: number) {
    if (!confirm("消去すると復元は出来ません\n本当によろしいですか？")) {
      return;
    }
    this.postJsonCheck(
      window.base_url + "/api/ibowaccount/hard-delete",
      {
        id: id,
      },
      () => {
        this.fetchIbowAccounts();
      }
    );
  }
}
